import { LitElement, html, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";
import { consume } from "@lit/context";
import { authContext, AuthState, envContext } from "@/context";
import { EnvConfig } from "@/types";

@customElement("sb-authenticated")
export class SbAuthenticated extends LitElement {
  private _cachedChildren: Node[] = [];

  createRenderRoot() {
    return this; // stay in light DOM
  }

  connectedCallback(): void {
    super.connectedCallback();
    if (this._cachedChildren.length === 0) {
      // detach and cache children once
      this._cachedChildren = Array.from(this.childNodes);
      this._cachedChildren.forEach((c) => this.removeChild(c));
    }
  }

  /**
   * The URL to redirect to if the user is not authenticated.
   * Defaults to environment variable, can be overridden via property.
   */

  @property({ type: String })
  redirectUrl: string = "";

  @consume({ context: envContext })
  @property({ attribute: false })
  env: EnvConfig | null = null;

  @consume({ context: authContext, subscribe: true })
  @property({ attribute: false })
  auth?: AuthState;

  render() {
    if (!this.auth) return nothing;

    if (!this.auth.isAuthenticated) {
      // Redirect to the given URL
      window.location.href = this.redirectUrl || this.env?.signinUrl!;
      return nothing;
    }

    return html`${this._cachedChildren}`;
  }
}
